import { AxiosInstance } from 'axios';
import {
  ClientContactEndpoints,
  SearchClientContactsRequest,
  SearchClientContactsResponse,
  CreateClientContactRequest,
  CreateClientContactResponse,
  DeleteClientContactRequest,
  DeleteClientContactResponse,
  UpdateClientContactRequest,
  UpdateClientContactResponse,
  InviteClientContactRequest,
  InviteClientContactResponse,
  GetByIdClientContactRequest,
  GetByIdClientContactResponse,
} from './ClientContactServices.types';

export class ClientContactServices implements ClientContactEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search({ queryParams, routeParams }: SearchClientContactsRequest) {
    return this.instance.get<SearchClientContactsResponse>(
      `/clients/${routeParams.clientGuid}/contacts`,
      {
        params: queryParams,
      },
    );
  }

  getById({ routeParams }: GetByIdClientContactRequest) {
    return this.instance.get<GetByIdClientContactResponse>(
      `/clients/${routeParams.clientGuid}/contacts/${routeParams.contactGuid}`,
    );
  }

  create(request: CreateClientContactRequest) {
    return this.instance.post<CreateClientContactResponse>(
      `/clients/${request.routeParams.accountId}/contacts`,
      request.body,
    );
  }

  update(request: UpdateClientContactRequest) {
    return this.instance.put<UpdateClientContactResponse>(
      `/clients/${request.routeParams.accountId}/contacts/${request.routeParams.contactId}`,
      request.body,
    );
  }

  delete(request: DeleteClientContactRequest) {
    return this.instance.delete<DeleteClientContactResponse>(
      `/clients/${request.routeParams.accountId}/contacts/${request.routeParams.contactId}`,
    );
  }

  invite({ routeParams, body }: InviteClientContactRequest) {
    return this.instance.put<InviteClientContactResponse>(
      `/clients/${routeParams.accountGuid}/contacts/${routeParams.contactGuid}/invite`,
      body,
    );
  }
}
